import { configureStore } from '@reduxjs/toolkit';
import sessionsReducer from './sessionsSlice';
import sessionLoaderReducer from './sessionLoaderSlice';
import devToolsReducer from './devToolsSlice';
import chatQueueReducer from './chatQueueSlice';
import chatContextReducer from '../chat-context/chatContextSlice';
import usageReducer from './usageSlice';
import nebulaBrainReducer from '../modules/portfolio-ai/store/nebulaBrainSlice';
import websocketReducer from './websocketSlice';
import { baseApi } from '../api/baseApi';

export const store = configureStore({
    reducer: {
        sessions: sessionsReducer,
        sessionLoader: sessionLoaderReducer,
        devTools: devToolsReducer,
        chatQueue: chatQueueReducer,
        chatContext: chatContextReducer,
        usage: usageReducer,
        nebulaBrain: nebulaBrainReducer,
        websocket: websocketReducer,
        [baseApi.reducerPath]: baseApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: ['websocket.ws'],
                ignoredActions: ['websocket/connect'],
            },
        }).concat(baseApi.middleware),
});

export * from './sessionsSlice';
export * from './sessionLoaderSlice';
export * from './devToolsSlice';
export * from './chatQueueSlice';
export * from './hooks';
export * from './usageSlice';
export * from './websocketSlice';
